var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewReportDisabled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "44px",
    viewBox: "0 0 39 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 17") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reports",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Reports-V1-#4---Report-Menu",
    transform: "translate(-975.000000, -266.000000)",
    stroke: "#D8D8D8",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(870.000000, 224.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(106.000000, 43.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4512,33.76 L27.4512,35.99 C27.4512,37.15 26.5112,38.09 25.3512,38.09 L2.1012,38.09 C0.9412,38.09 0.0012,37.15 0.0012,35.99 L0.0012,9.07 C0.0012,8.884 0.0742,8.709 0.2082,8.58 C1.5352,7.302 8.7712,0 8.7712,0 L25.3512,0 C26.5112,0 27.4512,0.94 27.4512,2.1 L27.4512,15.67",
    id: "Stroke-1",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.93,
    y1: 14.327,
    x2: 21.851,
    y2: 14.327,
    id: "Stroke-3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.5912,
    y1: 19.2,
    x2: 5.9312,
    y2: 19.2,
    id: "Stroke-5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.5612,
    y1: 24.07,
    x2: 5.9312,
    y2: 24.07,
    id: "Stroke-7",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.773,0.3554 L8.773,6.6234 C8.773,7.8274 7.797,8.8034 6.593,8.8034 L0,8.8034",
    id: "Stroke-9",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3455,24.9096 C36.3455,29.7996 32.3815,33.7636 27.4915,33.7636 C22.6015,33.7636 18.6375,29.7996 18.6375,24.9096 C18.6375,20.0196 22.6015,16.0556 27.4915,16.0556 C32.3815,16.0556 36.3455,20.0196 36.3455,24.9096 Z",
    id: "Stroke-11",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.4914,
    y1: 21.3506,
    x2: 27.4914,
    y2: 28.4686,
    id: "Stroke-13",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.0505,
    y1: 24.9096,
    x2: 23.9325,
    y2: 24.9096,
    id: "Stroke-15",
    strokeLinecap: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewReportDisabled);
export default __webpack_public_path__ + "static/media/new-report-disabled.988fa3e0e18ea29ceb5d5c5379525fa1.svg";
export { ForwardRef as ReactComponent };